module.exports = "../images/homepage/running.jpg";